import React from 'react';
import './DoctorCardSkeleton.css';

const DoctorCardSkeleton = () => {
    return (
        <div className="dc-searchresult-holder">
            <div className="dc-searchresult-head">
            </div>
            <div className="dc-searchresult-grid dc-searchresult-list dc-searchvlistvtwo skeleton-card">
                <div className="dc-docpostholder dc-search-hospitals">
                    <div className="dc-docpostcontent">
                        <div className="dc-searchvtwo col-lg-8 col-md-8 col-sm-8 col-xs-12">
                            {/* Doctor Image Skeleton */}
                            <figure className="dc-docpostimg skeleton-image">
                                <div className="skeleton-shimmer"></div>
                            </figure>
                            
                            <div className="dc-title">
                                {/* Speciality Badge Skeleton */}
                                <div className="dc-doc-specilities-tag">
                                    <div className="skeleton-badge skeleton-shimmer"></div>
                                    <div className="skeleton-badge-small skeleton-shimmer"></div>
                                </div>
                                
                                {/* Doctor Name Skeleton */}
                                <h3>
                                    <div className="skeleton-name skeleton-shimmer"></div>
                                    <div className="skeleton-verification skeleton-shimmer"></div>
                                    <div className="skeleton-verification skeleton-shimmer"></div>
                                </h3>
                                
                                {/* Ratings Skeleton */}
                                <div className="skeleton-ratings">
                                    <div className="skeleton-stars skeleton-shimmer"></div>
                                    <div className="skeleton-rating-text skeleton-shimmer"></div>
                                </div>
                                
                                {/* Education, Experience and Specializations Skeleton */}
                                <div className="dc-education-specializations" style={{ marginTop: '10px' }}>
                                    {/* Education Skeleton */}
                                    <div className="dc-education skeleton-info">
                                        <div className="skeleton-icon skeleton-shimmer"></div>
                                        <div className="skeleton-text skeleton-shimmer"></div>
                                    </div>
                                    
                                    {/* Experience Skeleton */}
                                    <div className="dc-experience skeleton-info">
                                        <div className="skeleton-icon skeleton-shimmer"></div>
                                        <div className="skeleton-text skeleton-shimmer"></div>
                                    </div>
                                    
                                    {/* Specialization Skeleton */}
                                    <div className="dc-specialization skeleton-info">
                                        <div className="skeleton-icon skeleton-shimmer"></div>
                                        <div className="skeleton-text skeleton-shimmer"></div>
                                        <div className="skeleton-badge-more skeleton-shimmer"></div>
                                    </div>
                                </div>
                            </div>
                            
                            {/* Tags Skeleton */}
                            <div className="dc-tags">
                                <div className="skeleton-tag skeleton-shimmer"></div>
                                <div className="skeleton-tag skeleton-shimmer"></div>
                                <div className="skeleton-tag skeleton-shimmer"></div>
                            </div>
                        </div>
                        
                        {/* Right Side Info Skeleton */}
                        <div className="dc-doclocation dc-doclocationvtwo col-lg-4 col-md-4 col-sm-4 col-xs-12">
                            {/* Location Skeleton */}
                            <span className="dc-location-span skeleton-location">
                                <div className="skeleton-icon skeleton-shimmer"></div>
                                <div className="skeleton-text skeleton-shimmer"></div>
                            </span>
                            
                            {/* Availability Skeleton */}
                            <div className="skeleton-availability">
                                <div className="skeleton-icon skeleton-shimmer"></div>
                                <div className="skeleton-text skeleton-shimmer"></div>
                            </div>
                            
                            {/* Fees Skeleton */}
                            <span className="skeleton-fees">
                                <div className="skeleton-icon skeleton-shimmer"></div>
                                <div className="skeleton-text skeleton-shimmer"></div>
                            </span>
                            
                            {/* Votes Skeleton */}
                            <span className="skeleton-votes">
                                <div className="skeleton-icon skeleton-shimmer"></div>
                                <div className="skeleton-text skeleton-shimmer"></div>
                            </span>
                            
                            {/* Buttons Skeleton */}
                            <div className="dc-btnarea">
                                <div className="skeleton-btn skeleton-shimmer"></div>
                                <div className="skeleton-heart skeleton-shimmer"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// Multiple skeleton cards component
export const DoctorCardsSkeleton = ({ count = 5 }) => {
    return (
        <>
            {/* Search Results Header Skeleton */}
            <div className="dc-searchresult-holder">
                <div className="dc-searchresult-head">
                    <div className="dc-title">
                        <div className="skeleton-matches skeleton-shimmer"></div>
                    </div>
                    <div className="dc-rightarea">
                        <div className="dc-select">
                            <div className="skeleton-select skeleton-shimmer"></div>
                        </div>
                        <div className="dc-select">
                            <div className="skeleton-select skeleton-shimmer"></div>
                        </div>
                    </div>
                </div>
            </div>
            
            {/* Render multiple skeleton cards */}
            {Array.from({ length: count }, (_, index) => (
                <DoctorCardSkeleton key={index} />
            ))}
        </>
    );
};

export default DoctorCardSkeleton;
